import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const PdfFileIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M52 8V24C52 32.8366 59.1634 40 68 40L84 40M12 24L12 72C12 80.8366 19.1634 88 28 88H68C76.8366 88 84 80.8366 84 72V46.6274C84 42.384 82.3143 38.3143 79.3137 35.3137L56.6863 12.6863C53.6857 9.68571 49.616 8 45.3726 8L28 8C19.1634 8 12 15.1634 12 24Z"
      stroke={props.color ?? "#1C1C1C"}
      strokeWidth={props.strokeWidth ?? "2.5"}
      strokeLinejoin="round"
    />
    <path
      d="M30.4465 54.425C34.4965 54.425 37.3965 56.675 37.3965 60.525C37.3965 64.4 34.4715 66.55 30.3465 66.55L27.0465 66.575V72H24.4715V54.425H30.4465ZM30.3215 64.25C32.9965 64.25 34.7215 62.775 34.7215 60.5C34.7215 58.225 32.9715 56.725 30.3215 56.725H27.0465V64.25H30.3215ZM46.8371 54.425C52.3621 54.425 56.0371 57.925 56.0371 63.2C56.0371 68.475 52.3621 72 46.8371 72H40.4871V54.425H46.8371ZM46.8121 69.7C50.8621 69.7 53.4121 67.1 53.4121 63.225C53.4121 59.35 50.8621 56.725 46.8121 56.725H43.0621V69.7H46.8121ZM71.0539 56.725H62.1539V63.175H70.0039V65.5H62.1539V72H59.5789V54.425H71.0539V56.725Z"
      fill={props.color ?? "#1C1C1C"}
    />
  </svg>
)
